import countries from "./countries"
import providedProducts from "./providedProducts"

export default {
    countries,
    providedProducts,
}